import { logWarning, logError } from '@/services/errorService'

let loadPromise: Promise<void> | null = null

export function initGoogleMapsAPI(): Promise<void> {
	const win = window as unknown as { google?: { maps?: unknown } }

	if (win.google?.maps) {
		return Promise.resolve()
	}

	if (loadPromise) {
		return loadPromise
	}

	const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
	if (!apiKey) {
		logWarning('[GoogleMaps] API key is not configured')
		return Promise.resolve()
	}

	loadPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = `${import.meta.env.VITE_GOOGLE_MAPS_API_URL}?key=${apiKey}&libraries=places`
		script.async = true
		script.defer = true

		script.onload = () => resolve()
		script.onerror = () => {
			logError('[GoogleMaps] Failed to load Google Maps API script')
			loadPromise = null
			reject(new Error('Failed to load Google Maps API'))
		}

		document.head.appendChild(script)
	})

	return loadPromise
}
